'use client'

import classNames from 'classnames'
import type { HTMLAttributes, ReactNode } from 'react'

interface ITableHeaderCellProps extends HTMLAttributes<HTMLTableCellElement> {
  className?: string
  children: ReactNode
}

export const PktTableHeaderCell = ({ className, children, ...props }: ITableHeaderCellProps) => (
  <th className={classNames(className, 'pkt-table__header-cell', {})} role="columnheader" {...props}>
    {children}
  </th>
)
